const env = {
    dashboard_uri: "//d.effie.cx",
    // Override eg by:
    // dashboard_uri: "http://localhost:5173"
}

export default env